import { ShieldAlert } from 'lucide-react'
import React from 'react'

import { Banner } from './banner'

import { IS_DEV } from '@/env'
import { clearImpersonationMarker, getImpersonatedEmail } from '@/features/auth/api/impersonate'
import { useAuth, useAuthApi } from '@/state/session'

export const ImpersonationBanner = () => {
  const auth = useAuth()
  const { logout } = useAuthApi()
  const [email, setEmail] = React.useState<string | null>(null)

  React.useEffect(() => {
    if (!IS_DEV) return
    const stored = getImpersonatedEmail()
    setEmail(stored)
  }, [auth.isAuthenticated])

  React.useEffect(() => {
    if (!auth.isAuthenticated && email) {
      clearImpersonationMarker()
      setEmail(null)
    }
  }, [auth.isAuthenticated, email])

  if (!IS_DEV || !auth.isAuthenticated || !email) {
    return null
  }

  const handleExit = async () => {
    clearImpersonationMarker()
    await logout()
  }

  return (
    <div className="px-4 pt-2">
      <Banner
        className='border-red-500 text-red-900'
        show
        onHide={() => undefined}
        icon={<ShieldAlert className="w-4 h-4 text-red-700" />}
        title={`Vous êtes en mode impersonation : ${email}`}
        action={{ label: 'Quitter', onClick: handleExit }}
      />
    </div>
  )
}
